var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrophy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.3497 14.011H23.521V12.7361H24.3497C27.8619 12.7361 30.7239 9.8741 30.7239 6.36188V4.46235H23.521V3.1875H31.9988V6.36188C31.9988 10.5753 28.5694 14.011 24.3497 14.011ZM7.64911 14.011H8.47776V12.7361H7.64911C4.13689 12.7361 1.27485 9.8741 1.27485 6.36188V4.46235H8.66899V3.1875H0V6.36188C0 10.5753 3.42935 14.011 7.64911 14.011Z",
    fill: "#EDA900"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3895 24.9922H5.60938V32.0039H26.3895V24.9922Z",
    fill: "#1F3F77"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3895 24.9922H5.60938V26.2989H26.3895V24.9922Z",
    fill: "#0A2751"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1109 30.0859H3.88867V31.9982H28.1109V30.0859Z",
    fill: "#3179AF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7374 30.0859H3.88867V31.9982H22.7374V30.0859Z",
    fill: "#68A1D6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.079 23.0703H11.9199V24.9826H20.079V23.0703Z",
    fill: "#E36414"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7524 23.0703H11.9199V24.9826H17.7524V23.0703Z",
    fill: "#F8961E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7.01172 0V13.4369C7.01172 15.3811 8.2802 17.0894 10.1351 17.6567C11.99 18.224 13.2585 19.9387 13.2585 21.8765V23.0748H18.7404V21.8765C18.7404 19.9323 20.0088 18.224 21.8637 17.6567C23.7187 17.0894 24.9871 15.3747 24.9871 13.4369V0H7.01172Z",
    fill: "#F8D707"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1109 24.6641H3.88867V25.3015H28.1109V24.6641Z",
    fill: "#3179AF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7565 24.6641H3.88867V25.3015H22.7565V24.6641Z",
    fill: "#68A1D6"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3735 27.2188H9.625V27.8562H22.3735V27.2188Z",
    fill: "#F8D707"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M7.01172 0V3.18713H16.0504C17.8862 3.18713 19.3778 4.67871 19.3778 6.51449V14.7564C19.3778 15.9548 18.734 17.0639 17.6886 17.6567C16.6432 18.2495 15.9994 19.3523 15.9994 20.557V23.0748H18.7404V21.8765C18.7404 19.9323 20.0088 18.224 21.8637 17.6567C23.7187 17.0894 24.9871 15.3747 24.9871 13.4369V0H7.01172Z",
    fill: "#EDA900"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8793 0H6.11914V1.91228H25.8793V0Z",
    fill: "#F8D707"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4405 0H7.83984V1.91228H10.4405V0Z",
    fill: "#FFFA5A"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1025 0H12.9082V1.91228H17.1025V0Z",
    fill: "#FFFA5A"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4738 4.46094C10.0906 4.46094 8.96875 5.58281 8.96875 6.96602V9.02491C8.96875 10.4081 10.0906 11.53 11.4738 11.53C12.857 11.53 13.9789 10.4081 13.9789 9.02491V6.96602C13.9789 5.58281 12.857 4.46094 11.4738 4.46094Z",
    fill: "#FFFA5A"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M3.26999 4.46235H0V3.1875H3.26999C3.62058 3.1875 3.90742 3.47434 3.90742 3.82493C3.90742 4.17551 3.62695 4.46235 3.26999 4.46235Z",
    fill: "#F8D707"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M0.637426 6.36188C0.286842 6.36188 0 6.07504 0 5.72446V3.1875H1.27485V5.72446C1.27485 6.07504 0.98801 6.36188 0.637426 6.36188Z",
    fill: "#F8D707"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophy);
export default __webpack_public_path__ + "static/media/trophy.8940396c2244cbca67a111e2534eb520.svg";
export { ForwardRef as ReactComponent };